// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===============================
   GLOBAL RESET & SCROLL CONTROL
   =============================== */

html,
body {
  height: 100%;
  margin: 0;
  overflow: hidden; /* ⛔ NEVER allow page scroll */
  font-family: -apple-system, BlinkMacSystemFont,
               "Segoe UI", Roboto, Helvetica, Arial,
               sans-serif;
}

/* ===============================
   HEADER
   =============================== */

.header {
  height: 56px;
  background: #e8f1fb;              /* light blue */
  color: #1f2937;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  border-bottom: 1px solid #c7d2fe;
}

.header-title {
  font-size: 18px;
  font-weight: 600;
  color: #1e3a8a;
}

.logout-btn {
  background: #2563eb;
  color: white;
  border: none;
  padding: 6px 14px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
}

/* ===============================
   APP LAYOUT (BELOW HEADER)
   =============================== */

.app-layout {
  display: flex;
  height: calc(100vh - 56px); /* exact header height */
  overflow: hidden; /* ⛔ stop page scroll */
}

/* ===============================
   SIDEBAR
   =============================== */

.sidebar {
  width: 260px;
  background: #eef5ff;
  border-right: 1px solid #c7d2fe;
  display: flex;
  flex-direction: column;
  overflow: hidden; /* ⛔ contain sidebar */
}

/* New Cohort button */
.menu-link.new-chat {
  margin: 12px;
  padding: 10px;
  border-radius: 6px;
  background: #dbe7ff;
  font-weight: 600;
  cursor: pointer;
}

.menu-link.new-chat:hover {
  background: #c7d8ff;
}

/* Sidebar title */
.sidebar-title {
  padding: 10px 16px;
  font-size: 13px;
  font-weight: 600;
  color: #1e40af;
}

/* Sidebar menu (THIS SCROLLS) */
.sidebar .menu {
  flex: 1 1;
  overflow-y: auto; /* ✅ sidebar scroll */
  padding: 0 8px 8px 8px;
}

.sidebar .menu li {
  list-style: none;
}

/* Sidebar item */
.menu-link {
  padding: 8px 10px;
  border-radius: 4px;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.menu-link:hover {
  background: #dbe7ff;
}

.menu-link.disabled {
  color: #94a3b8;
  cursor: not-allowed;
}

/* ===============================
   MAIN CONTENT AREA
   =============================== */

.content {
  flex: 1 1;
  overflow: hidden; /* ⛔ prevent page scroll */
  background: #f8fafc;
  padding: 0;
}
`, "",{"version":3,"sources":["webpack://./src/styles/layout.css"],"names":[],"mappings":"AAAA;;oCAEoC;;AAEpC;;EAEE,YAAY;EACZ,SAAS;EACT,gBAAgB,EAAE,8BAA8B;EAChD;;yBAEuB;AACzB;;AAEA;;oCAEoC;;AAEpC;EACE,YAAY;EACZ,mBAAmB,eAAe,eAAe;EACjD,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;;oCAEoC;;AAEpC;EACE,aAAa;EACb,0BAA0B,EAAE,wBAAwB;EACpD,gBAAgB,EAAE,uBAAuB;AAC3C;;AAEA;;oCAEoC;;AAEpC;EACE,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,gBAAgB,EAAE,sBAAsB;AAC1C;;AAEA,sBAAsB;AACtB;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,SAAO;EACP,gBAAgB,EAAE,qBAAqB;EACvC,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;oCAEoC;;AAEpC;EACE,SAAO;EACP,gBAAgB,EAAE,0BAA0B;EAC5C,mBAAmB;EACnB,UAAU;AACZ","sourcesContent":["/* ===============================\n   GLOBAL RESET & SCROLL CONTROL\n   =============================== */\n\nhtml,\nbody {\n  height: 100%;\n  margin: 0;\n  overflow: hidden; /* ⛔ NEVER allow page scroll */\n  font-family: -apple-system, BlinkMacSystemFont,\n               \"Segoe UI\", Roboto, Helvetica, Arial,\n               sans-serif;\n}\n\n/* ===============================\n   HEADER\n   =============================== */\n\n.header {\n  height: 56px;\n  background: #e8f1fb;              /* light blue */\n  color: #1f2937;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 20px;\n  border-bottom: 1px solid #c7d2fe;\n}\n\n.header-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #1e3a8a;\n}\n\n.logout-btn {\n  background: #2563eb;\n  color: white;\n  border: none;\n  padding: 6px 14px;\n  border-radius: 4px;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n/* ===============================\n   APP LAYOUT (BELOW HEADER)\n   =============================== */\n\n.app-layout {\n  display: flex;\n  height: calc(100vh - 56px); /* exact header height */\n  overflow: hidden; /* ⛔ stop page scroll */\n}\n\n/* ===============================\n   SIDEBAR\n   =============================== */\n\n.sidebar {\n  width: 260px;\n  background: #eef5ff;\n  border-right: 1px solid #c7d2fe;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden; /* ⛔ contain sidebar */\n}\n\n/* New Cohort button */\n.menu-link.new-chat {\n  margin: 12px;\n  padding: 10px;\n  border-radius: 6px;\n  background: #dbe7ff;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.menu-link.new-chat:hover {\n  background: #c7d8ff;\n}\n\n/* Sidebar title */\n.sidebar-title {\n  padding: 10px 16px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #1e40af;\n}\n\n/* Sidebar menu (THIS SCROLLS) */\n.sidebar .menu {\n  flex: 1;\n  overflow-y: auto; /* ✅ sidebar scroll */\n  padding: 0 8px 8px 8px;\n}\n\n.sidebar .menu li {\n  list-style: none;\n}\n\n/* Sidebar item */\n.menu-link {\n  padding: 8px 10px;\n  border-radius: 4px;\n  cursor: pointer;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.menu-link:hover {\n  background: #dbe7ff;\n}\n\n.menu-link.disabled {\n  color: #94a3b8;\n  cursor: not-allowed;\n}\n\n/* ===============================\n   MAIN CONTENT AREA\n   =============================== */\n\n.content {\n  flex: 1;\n  overflow: hidden; /* ⛔ prevent page scroll */\n  background: #f8fafc;\n  padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
